<div class="container">
  <div class="card p-3 ">
    <h4>{{textDisplay}}</h4>

    <form class="" *ngIf="question && question.examinationQuestionID else noQuestion">
      <div class="d-flex justify-content-center mb-3 text-danger" *ngIf="modelError">
        <p>{{modelError}}</p>
      </div>
      <div class="row">

        <div class="mb-3 mr-0 col">
          <label class="form-label">Marks</label>
          <input class="form-control" type="number" min="0" [(ngModel)]="question.marks"
            [ngModelOptions]="{ standalone: true }" disabled="true">
        </div>
        <div class="mb-3 mr-0 col">
          <label class="form-label">Penalty Marks</label>
          <input class="form-control" id="modelError" type="number" min="0" [(ngModel)]="question.penaltyMarks"
            [ngModelOptions]="{ standalone: true }" disabled="true">
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col">
          <label class="form-label">Question Category</label>
          <ng-select class="form-select" [(ngModel)]="question.category" [ngModelOptions]="{ standalone: true }"
            disabled="true">
            <ng-option selected value="" disabled>Select Category</ng-option>
            <ng-option *ngFor="let cat of categoryList" [value]="cat.category">{{cat.category}}</ng-option>
          </ng-select>

        </div>
        <div class="mb-3 mr-0 col">
          <div class="dropdown">
            <label class="form-label">Language</label>
            <ng-select class="form-select form-control" id="language" name="language" [(ngModel)]="question.language">
              <ng-option value="" disabled selected>Select Language</ng-option>
              <ng-option *ngFor="let lang of languages" [value]="lang.code">{{lang.lang}}</ng-option>
            </ng-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 mr-0 col">
          <label class="form-label">Question</label>
          <div [innerHTML]="question.questionHtml" class="border p-3 rounded"></div>
        </div>
      </div>
      <hr>

      <div class="mb-3 mr-0 col" *ngIf="question.questionType =='SAQ'">
        <label class="form-label">SAQ Possible Answers (separator '|')</label>
        <input class="form-control" type="text" [(ngModel)]="question.saqPossibleAnsers"
          [ngModelOptions]="{ standalone: true }" disabled="true">
      </div>
      <div class="mt-2">
        <div class="form-check" *ngFor="let answer of question?.saqAnswersList; let i = index">
          <input class="form-check-input" type="checkbox" [id]="'answer-' + i" [(ngModel)]="answer.isChecked"
            (ngModelChange)="updateSaqPossibleAnswers()" [ngModelOptions]="{ standalone: true }">
          <label class="form-check-label" [for]="'answer-' + i">
            {{answer?.value}}
          </label>
        </div>
      </div>

      <div class="">

        <div class="row mt-3">
          <div class="mb-3 mr-0 col">
            <input class="form-control text-white bg-primary" [style.opacity]="changeMade ? '1' : '0.5'"
              [style.cursor]="changeMade ? 'pointer' : 'not-allowed'" type="button" value="Update Selection"
              (click)="saveQuestion(true)" [disabled]="!changeMade">

          </div>
          <div class="mb-3 mr-0 col">
            <input class="form-control bg-secondary text-white" type="button" value="Cancel" (click)="cancel()">
          </div>
        </div>


      </div>
    </form>

    <ng-template #noQuestion>
      <div class="text-center p-4">
        <p>Please select a question</p>
      </div>
    </ng-template>

  </div>
</div>